import { AppContent } from 'content/AppContent';

const registrationInProgress: AppContent['registrationInProgress'] = {
  registrationInProgressContent: [
    {
      serviceName: 'Online for Business',
      header: 'Your registration is already in progress',
      infoNotification:
        'We’re still working on your earlier request to register',
      content1:
        'Once our final checks are complete, we’ll email you to let you know what happens next.',
      content2: 'The reference number for your application is',
      backToWebsiteButton: 'Back to lloydsbank.com',
      backToWebsiteLink:
        'https://www.lloydsbank.com/business/banking-online/online-for-business/register-for-online-for-business.html',
    },
  ],
};

export default registrationInProgress;
